var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DropdownButton, Icon } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import * as React from 'react';
import { metaConversation } from 'components/conversation/utils/conversationObjectConverters';
import { ConversationDetails, ConversationDetailsLayout, } from 'components/conversationsOverview/components/ConversationDetails';
import { clickWithFocus } from 'components/shared/util/clickWithFocus';
import styles from './subConversationList.module.scss';
export class SubConversationList extends React.PureComponent {
    getDropdownContent(linkedConversations) {
        const { onConversationClick } = this.props;
        return (_jsx("div", Object.assign({ className: styles.dropdownContent }, { children: linkedConversations.map((linkedConversation, index) => {
                var _a;
                return (_jsx("div", Object.assign({}, clickWithFocus(() => {
                    if (linkedConversation.info.id) {
                        onConversationClick(linkedConversation.info.id);
                    }
                }), { children: _jsx(ConversationDetails, { className: styles.dropdownItem, conversationName: (_a = linkedConversation.labels.title) !== null && _a !== void 0 ? _a : null, layout: ConversationDetailsLayout.SideConversation, metaConversation: metaConversation.from.conversation(linkedConversation.info, linkedConversation.requester) }) }), `${linkedConversation.info.id}-${index}`));
            }) })));
    }
    render() {
        const _a = this.props, { className, conversations, onConversationClick } = _a, otherProps = __rest(_a, ["className", "conversations", "onConversationClick"]);
        const rootClass = classnames({
            [styles.root]: true,
        }, className);
        let visibleConversations = conversations;
        let extraConversations = null;
        if (conversations.length > 3) {
            visibleConversations = conversations.slice(0, 3);
            extraConversations = conversations.slice(3);
        }
        return (_jsxs("div", Object.assign({}, otherProps, { className: rootClass }, { children: [visibleConversations.length > 0 && (_jsx(Icon, { name: "link", size: 16, className: styles.linkIcon })), visibleConversations.map((linkedConversation, index) => {
                    var _a;
                    return (_jsx("div", Object.assign({ className: styles.item }, { children: _jsx("div", Object.assign({ className: styles.itemInner }, clickWithFocus(() => {
                            if (linkedConversation.info.id) {
                                onConversationClick(linkedConversation.info.id);
                            }
                        }), { children: _jsx(ConversationDetails, { conversationName: (_a = linkedConversation.labels.title) !== null && _a !== void 0 ? _a : null, layout: ConversationDetailsLayout.SideConversation, metaConversation: metaConversation.from.conversation(linkedConversation.info, linkedConversation.requester) }) })) }), `${linkedConversation.info.id}-${index}`));
                }), !!extraConversations && (_jsx(DropdownButton, Object.assign({ buttonProps: { className: styles.dropdownButton }, noArrow: true, dropdown: this.getDropdownContent(extraConversations) }, { children: `+${extraConversations.length}` })))] })));
    }
}
